import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useECharts } from '@/hooks/useECharts';
  import { isEmptyData } from '@/utils/common';
  import { groupBy, isNil } from 'lodash-es';
  import { Ref, ref, watch } from 'vue';
  import { useTableContext } from '../hooks/useTableContext';

  interface Props {
    echart_type?: string;
    x_axis: Recordable;
    y_axises: Recordable[];
    pie_field: Recordable;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    echart_type: { default: 'line' },
    x_axis: { default: () => ({}) },
    y_axises: { default: () => [] },
    pie_field: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { echart_type: string, x_axis: Recordable, y_axises: Recordable[], pie_field: Recordable }

  
  const chart_data = ref<Recordable[]>([]);
  const table_chart_ref = ref<HTMLDivElement | null>(null);
  const table = useTableContext();
  const api = table.getProps.value.api;
  const get_table_data = async () => {
    const selected_rows = table.getSelectRows();
    let table_data: any = [];
    if (selected_rows.length === 0) {
      if (api) {
        const result_items = await table.fetchAllNoChange();
        table_data = result_items;
      } else {
        table_data = table.getDataSource();
      }
    } else {
      table_data = selected_rows;
    }
    chart_data.value = table_data;
  };
  const { setOption } = useECharts(table_chart_ref as Ref<HTMLDivElement>);
  const show_chart = () => {
    const filter_field = props.echart_type !== 'pie' ? props.x_axis.dataIndex : props.pie_field.dataIndex;
    if (!filter_field) {
      return false;
    } else {
      const grouped_chart_data = groupBy(chart_data.value, filter_field);
      if (props.echart_type !== 'pie') {
        const x_axis_data: string[] = [];
        const legend_data = props.y_axises.map((item) => item.title);
        //横坐标配置
        const xAxis: Recordable = {
          type: 'category',
          data: x_axis_data,
          boundaryGap: false,
        };
        const yAxis: Recordable = {
          type: 'value',
        };
        Reflect.ownKeys(grouped_chart_data).forEach((item) => {
          if (isEmptyData(item)) {
            x_axis_data.push('未知');
          } else {
            let value: any = '-';

            if (props.x_axis.format) {
              if (item === 'true') {
                value = props.x_axis.format(true);
              } else if (item === 'false') {
                value = props.x_axis.format(false);
              } else if (!isNil(Number(item))) {
                value = props.x_axis.format(Number(item));
              } else {
                value = props.x_axis.format(item);
              }
            } else {
              value = item;
            }
            x_axis_data.push(value as string);
          }
        });
        const series: Recordable[] = [];
        props.y_axises.forEach((item) => {
          let data: any = [];
          data = Reflect.ownKeys(grouped_chart_data).map((mtem) => {
            let total = 0;
            if (item.componentType === 'we-number-range') {
              grouped_chart_data[mtem as string].forEach((ftem) => {
                if (!isEmptyData(ftem[item.dataIndex as string])) {
                  total += ftem[item.dataIndex as string];
                }
              });
            } else {
              total = grouped_chart_data[mtem as string].filter((ftem) => !isEmptyData(ftem[item.dataIndex])).length;
            }
            return total;
          });
          series.push({
            name: item.title,
            type: props.echart_type,
            data,
          });
        });
        setOption({
          tooltip: {
            trigger: 'axis',
            appendToBody: true,
            confine: true,
          },
          toolbox: {
            show: true,
            feature: {
              mark: { show: true },
              dataView: { show: true, readOnly: false },
              restore: { show: true },
              saveAsImage: { show: true },
            },
            itemGap: 24,
            left: 'left',
          },
          yAxis,
          xAxis,
          legend: {
            data: legend_data,
          },
          series,
        });
        return true;
      } else {
        const config: Recordable = {
          legend: {
            type: 'scroll',
            orient: 'vertical',
            right: 10,
            top: 20,
            bottom: 20,
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)',
            appendToBody: true,
            confine: true,
          },
          toolbox: {
            show: true,
            feature: {
              mark: { show: true },
              dataView: { show: true, readOnly: false },
              restore: { show: true },
              saveAsImage: { show: true },
            },
            itemGap: 24,
            left: 'left',
          },
        };
        const data = Reflect.ownKeys(grouped_chart_data).map((item) => {
          const obj: Recordable = {
            value: grouped_chart_data[item as string].length,
          };
          if (props.pie_field.format) {
            if (item === 'true') {
              obj.name = props.pie_field.format(true);
            } else if (item === 'false') {
              obj.name = props.pie_field.format(false);
            } else if (!isNil(Number(item))) {
              obj.name = props.pie_field.format(Number(item));
            } else {
              obj.name = props.pie_field.format(item);
            }
          } else {
            obj.name = item;
          }
          return obj;
        });
        config.series = {
          name: props.pie_field.title,
          type: 'pie',
          radius: '55%',
          center: ['50%', '50%'],
          roseType: 'area',
          itemStyle: {
            borderRadius: 8,
          },
          data,
        };
        setOption(config);
        return true;
      }
    }
  };
  get_table_data();
  watch(chart_data, () => show_chart());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "table_chart_wrapper",
    id: "table_chart_wrapper",
    ref: (_value, _refs) => {
      _refs['table_chart_ref'] = _value
      table_chart_ref.value = _value
    }
  }, null, 512))
}
}

})